import { Modal } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { setModalState } from '../../../../reducers/Modal/actions';
import { MODAL_EDIT_FIELD } from '../../../../reducers/Modal/types';

import './index.scss';

export const EditFieldModal = ({ children, selectedField }) => {
  const dispatch = useDispatch();
  const { isEditFieldModalOpen } = useSelector(
    ({ ModalReducer }) => ModalReducer,
  );

  const handleClose = () => {
    dispatch(setModalState(MODAL_EDIT_FIELD, false));
  };

  return (
    <Modal
      open={isEditFieldModalOpen}
      title={selectedField?.label}
      footer={null}
      onCancel={handleClose}
      destroyOnClose
      className="edit-field-modal"
    >
      {children}
    </Modal>
  );
};
